import React, { useState } from 'react';
import { useOtherStyles } from '../../App';
import { ExpertMinimal, LoadingProps } from '../../@types';
import { getExperts, getUsers } from '../../axios/user';
import Typography from '@material-ui/core/Typography';
import NoItems from '../../common/List/NoItems';
import ItemList from '../../common/List/ItemList';
import SearchBar from '../../common/Searchbars/SearchBar';
import SubmitButton from '../../common/Button/SubmitButton';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import IsLoadingHOC from '../../IsLoadingHOC';

const useStyles = makeStyles(() => ({
	createItemButton: {
		// position: 'fixed',
		// right: '10vw',
		// bottom: 100,
		float: 'right',
		padding: '10px',
		fontSize: '10px',
		width: '250px',
		margin: '10px 0px 0px',
	},
}));

export const AllExperts = (props: LoadingProps) => {
	const globalClasses = useOtherStyles();
	const [open, setOpen] = useState(false);
	
	const handleCreateNewItem = () => {
		// history.push(`/investigations/new`);
		setOpen(true)
	};

	const handleClose = () => {
		setOpen(false)
	}
	const [experts, setExperts] = React.useState<ExpertMinimal[]>([]);
	React.useEffect(() => {
		// getExperts()
		props.setLoading(true)
		getUsers()
			.then((res: any) => {
				setExperts(res.data);
				props.setLoading(false)
			})
			.catch((err: any) => {
				console.log(err)
				props.setLoading(false)
			});
	}, []);
	
	const handleSearch = () => {
		
	}
    
	return (
		<>
			<Typography variant='h4' className={globalClasses.banner}>
				All Experts
			</Typography>
			<Typography variant='subtitle2' className={globalClasses.info}>
				All the active experts on COSINT
			</Typography>

			<hr className={globalClasses.hrDivider} />

			<ItemList isUser={true} name="experts" items={experts} />
		</>
	);
}

export default IsLoadingHOC(AllExperts);
